// John Eldhose 20190619
import { RestfulPost } from './Restful';

export async function taxRate(data) {
  const tax = await RestfulPost('taxRate', data, (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return tax;
}



// WEBPACK FOOTER //
// ./src/Api/taxRate.js